import { Injectable } from '@angular/core';
import { GenericPrintCardContentViewModel } from '../../shared/generic-print-card-content-view-model';

@Injectable()
export class GenericPostCardStackContentViewModel extends GenericPrintCardContentViewModel {}
